const sellers = {
  first_name: 'Seller First Name',
  last_name: 'Seller Last Name',
  company_name: 'Seller Company Name',
};

export default sellers;
